import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button, Modal } from '@lt/components';
import { Sizes } from '@lt/components/components/Button/Button';
import withMobile from '../hocs/withMobile';
import CertificateContainer from '../containers/CertificateContainer';
import { formatCurrency } from '../../../utils/stringUtils';
import { NBSP } from '../../../constants/common';

const SuccessPopup = ({
  isShown,
  amount,
  clientEmail,
  isMobile,
  link,
  errorMessage,
  handleFetchCertLink,
}) => {
  useEffect(() => {
    if (isShown) {
      handleFetchCertLink();
    }
  }, [isShown, handleFetchCertLink]);

  if (!isShown) {
    return null;
  }

  return (
    <StyledModal shadow={false} isMobile={isMobile}>
      <StyledContainer>
        <StyledCertificateContainer width={isMobile ? 100 : 260} />
        <StyledText>
          {`Поздравляем!
        Вы${NBSP}приобрели${NBSP}подарочный сертификат${NBSP}на${NBSP}${formatCurrency(
            amount,
          )}`}
        </StyledText>
        <StyledSubText>
          Мы отправили его на ваш email:
          <span>{clientEmail}</span>
        </StyledSubText>
        {errorMessage && (
          <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
        )}
        <ButtonsContainer>
          {link ? (
            <Link href={link} target="_blank" rel="noreferrer" download>
              <StyledButton primary>Скачать PDF версию</StyledButton>
            </Link>
          ) : null}

          <Link href="/">
            <StyledButton>Вернуться на главную</StyledButton>
          </Link>
        </ButtonsContainer>
      </StyledContainer>
    </StyledModal>
  );
};

const StyledContainer = styled.div`
  padding: 30px 150px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0 10px 15px 0 rgba(170, 170, 170, 0.9),
    0 1px 2px 0 rgba(213, 213, 213, 0.9);
`;

const StyledText = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledSubText = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  color: ${(props) => props.theme.colors.blackBase};

  span {
    margin-left: 3px;
    font-weight: 500;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 480px;
  justify-content: space-between;
`;

const Link = styled.a`
  margin: auto;
`;

const StyledButton = styled(Button).attrs({ size: Sizes.FLEX })`
  min-width: 220px;
  font-size: 14px;
`;

const StyledCertificateContainer = styled(CertificateContainer)`
  margin-bottom: 20px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
`;

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.35);

  ${({ isMobile }) =>
    isMobile &&
    css`
      background-color: rgba(255, 255, 255, 0.5);

      ${StyledContainer} {
        padding: 20px 35px 30px;
        box-sizing: border-box;
        max-width: 95vw;
      }

      ${ButtonsContainer} {
        width: 230px;
        height: 100px;
        flex-direction: column;
      }
    `}
`;

const StyledErrorMessage = styled.div`
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.monza};
`;

SuccessPopup.propTypes = {
  isShown: PropTypes.bool,
  isMobile: PropTypes.bool,
  errorMessage: PropTypes.string,
  link: PropTypes.string,
};
SuccessPopup.defaultProps = {
  isShown: false,
  isMobile: false,
  errorMessage: null,
  link: null,
};

export default withMobile(SuccessPopup);
